<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex
        xs12
        sm12
        md3
        xl3>
        <formAdminMonthlyCrossChargeFilter :view="'aws-agreement'"/>
      </v-flex>
      <v-flex
        md9
        xl9/>
      <v-flex
        xs12
        sm12
        md12>
        <formAdminFinancialMonthlyDatatable :type="'By AWS Agreement'"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
  }),
  computed: {},

  methods: {}
}
</script>
<style lang="scss" scoped>
</style>
